import React, { useEffect, useState } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import AdminDashboard from './components/AdminDashboard';
import SemesterForm from './components/SemesterForm';
import CourseSelector from './components/CourseSelector';
import CsvUpload from './components/CsvUpload';
import CalendarView from './components/CalendarView';
import CourseDetails from './components/CourseDetails';
import NewCourseForm from './components/NewCourseForm';
import ManageCourses  from './components/ManageCourses';
import NewSemesterImport from './components/NewSemesterImport';
import Hero from './components/Hero';
import { apiFetch } from './api'
import Login from './components/Login'
import AnalyticsDashboard from './components/AnalyticsDashboard';
import AdminSurveys from './components/AdminSurveys';
import AdminXmasGreetings from './components/AdminXmasGreetings';
import AdminEvents from './components/AdminEvents';



export default function App() {
  const [isAuth, setIsAuth]           = useState(null)

  const [semesters, setSemesters] = useState([]);
  const [selectedSemester, setSelectedSemester] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedDegree, setSelectedDegree] = useState('');
  const [events, setEvents] = useState([]);
  const [mode, setMode] = useState('dashboard'); // 'dashboard', 'courses', 'create-new', 'duplicate', 'manage'
  const [importCfg, setImportCfg] = useState(null);

  // ➊ On mount, check if we’re already logged in (session cookie):
useEffect(() => {
  apiFetch('check_login.php')
    .then(r => r.json())
    .then(js => {
      const isLoggedIn = !!js.user_id;
      setIsAuth(isLoggedIn);
      if (isLoggedIn) loadSemesters();
    })
    .catch(() => setIsAuth(false));
}, []);



  // ➋ Your login callback:
  const handleLoginSuccess = () => {
    setIsAuth(true)
    // once logged-in, you can load data:
    loadSemesters()
  }

  // ➌ existing data‐loading:
  const loadSemesters = async () => {
    const res = await apiFetch('get_semesters.php')
    const data = await res.json()
    setSemesters(data)
  }


  // ➤ bring back loadEvents
  const loadEvents = async () => {
    const res = await apiFetch('load_events.php')
    const data = await res.json()
    setEvents(data.map(e => ({
      title: e.course_title,
      start: new Date(e.course_date_from + 'T' + e.course_start),
      end:   new Date(e.course_date_from + 'T' + e.course_end),
    })))
  }


  // ➍ If auth‐status is still loading, show nothing/spinner:
  if (isAuth === null) return <div>Loading…</div>

  // ➎ If not authenticated, show login:
  if (!isAuth) {
    return <Login onLogin={handleLoginSuccess} />
  }


  return (
    <>
      <Hero />
    <div className="app-layout">
      <Sidebar mode={mode} setMode={setMode} />

      <div className="main-content">
        {/* DASHBOARD */}
        {mode === 'dashboard' && (
          <div className="card">
            <AdminDashboard semesters={semesters} loadSemesters={loadSemesters} />
          </div>
        )}

        {/* KURSVERWALTUNG */}
        {mode === 'courses' && (
          <div className="card">
            <h2>Kursverwaltung</h2>
            <p>Was möchtest du tun?</p>
            <div className="flex" style={{ gap: '1rem', marginTop: '1rem' }}>
              <button className="primary" onClick={() => setMode('create-new')}>Neuen Kurs anlegen</button>
              <button className="primary" onClick={() => setMode('duplicate')}>Kurs mit alten Daten</button>
              <button className="secondary" onClick={() => setMode('manage')}>Bestehenden Kurs verwalten</button>
            </div>
          </div>
        )}
        {mode === 'analytics' && (
  <div className="card">
    <AnalyticsDashboard />
  </div>
)}
{mode === 'xmas-greetings' && (
  <div className="card">
    <AdminXmasGreetings />
  </div>
)}
 {/* SURVEYS (Admin) */}
       {mode === 'surveys' && (
         <div className="card">
          <AdminSurveys />
        </div>
       )}


        {/* NEUEN KURS ANLEGEN */}
        {mode === 'create-new' && (
  <div className="card">
    <NewCourseForm semesters={semesters} />
  </div>

  
)}


{/* NEUES SEMESTER + IMPORT */}
{mode === 'new-semester-import' && (
  <NewSemesterImport
     semesters={semesters}
     onBack={()=>setMode('courses')}
     onDone={()=>{
        loadSemesters();      // Liste auffrischen
        setMode('manage');    // danach evtl. gleich in die Verwaltung springen
     }}
  />
)}


        {/* KURS MIT ALTEN DATEN */}
        {mode === 'duplicate' && (
          <>
            <div className="card">
              <h2>Semester wählen</h2>
              <select
                onChange={(e) => {
                  setSelectedSemester(e.target.value);
                  setSelectedCourse(null);
                }}
                value={selectedSemester || ''}
              >
                <option value="">-- Semester wählen --</option>
                {semesters.map((s) => (
                  <option key={s.id} value={s.id}>{s.name} ({s.short})</option>
                ))}
              </select>
            </div>

            {selectedSemester && (
              <>
                <div className="card">
                  <CourseSelector onSelect={setSelectedCourse} onDegreeChange={setSelectedDegree} />
                </div>

                {selectedCourse && (
                  <div className="card">
                    <CourseDetails title={selectedCourse} degree={selectedDegree} semester={selectedSemester} />
                    <CsvUpload onImport={loadEvents} selectedSemesterId={selectedSemester} selectedCourseTitle={selectedCourse} />
                    <div style={{ marginTop: '2rem' }}>
                      <CalendarView events={events} />
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}

        {/* KURS VERWALTEN  */}
        {mode === 'manage' && (
          <div className="card">
            <ManageCourses semesters={semesters} />
          </div>
        )}
        {mode === 'events' && (
  <div className="card"><AdminEvents /></div>
)}
      </div>
    </div>
    </>
  );
}
